import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import PlainButton from 'app/common/ui-next/plain-button'
import PlainConfirmModal from 'app/common/ui-next/plain-confirm-modal'
import useCallbackRef from 'app/common/hooks/useCallbackRef'


type Props = {
  className?: string
  transfering?: boolean
  disabled?: boolean
  showConfirmation: boolean
  onSubmit: () => void
  setShowConfirmation: (state: boolean) => void
}

export const ControlSubmit = ({
  className,
  transfering,
  disabled,
  showConfirmation,
  onSubmit,
  setShowConfirmation,
}: Props) => {
  const { t } = useTranslation('finances')
  const onSubmitRef = useCallbackRef(onSubmit)

  const handleCancel = useCallback(() => {
    setShowConfirmation(false)
  }, [setShowConfirmation])

  const handleConfirm = useCallback(() => {
    setShowConfirmation(false)
    onSubmitRef.current?.()
  }, [onSubmitRef, setShowConfirmation])

  const buttonReadyTitle = t('transfer_bt', 'Перевести')

  return (
    <>
      <PlainButton
        className={className}
        disabled={disabled || transfering}
        type="submit"
      >
        {transfering
          ? t('transfer_bt_loading', 'Выполняется перевод')
          : buttonReadyTitle}
      </PlainButton>

      {showConfirmation
        && <PlainConfirmModal
          messageText={t('transfer_confirm', 'Вы уверены?') ?? ''}
          confirmButtonTitle={t('transfer_confirm_bt', 'Да') as string}
          cancelButtonTitle={t('transfer_cancel_bt', 'Отмена') as string}
          onCancel={handleCancel}
          onConfirm={handleConfirm}
        />}
    </>
  )
}
